var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-card",
    { staticClass: "centered card" },
    [
      _c(
        "sui-card-content",
        [
          _c(
            "div",
            {
              staticClass: "center aligned header",
              staticStyle: { margin: "1.5em" },
            },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _vm.isPasswordResetSuccessful === false
            ? [
                _c(
                  "sui-form",
                  { staticClass: "password-reset-form" },
                  [
                    _c(
                      "sui-form-field",
                      [
                        _c("label", [_vm._v("New Password")]),
                        _c("sui-input", {
                          attrs: {
                            type: "password",
                            placeholder: "New password",
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.newPassword,
                            callback: function ($$v) {
                              _vm.newPassword = $$v
                            },
                            expression: "newPassword",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "sui-form-field",
                      [
                        _c("label", [_vm._v("Confirm New Password")]),
                        _c("sui-input", {
                          attrs: {
                            type: "password",
                            placeholder: "Confirm new password",
                            autocomplete: "off",
                          },
                          model: {
                            value: _vm.newPasswordConfirmation,
                            callback: function ($$v) {
                              _vm.newPasswordConfirmation = $$v
                            },
                            expression: "newPasswordConfirmation",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("sui-button", {
                      attrs: {
                        type: "button",
                        fluid: "",
                        color: "teal",
                        content: "Save Password",
                      },
                      on: { click: _vm.resetPassword },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.isPasswordResetSuccessful
            ? [
                _c(
                  "sui-message",
                  { attrs: { positive: "" } },
                  [
                    _c("sui-message-content", [
                      _vm._v(
                        " Your password has been reset successfully with the new password. "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "center aligned" },
                  [
                    _c(
                      "router-link",
                      {
                        staticStyle: { color: "#2a998b" },
                        attrs: { to: "/account/login" },
                      },
                      [_vm._v("Log in?")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }